/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/InternalQueryServiceAPI',
	'../../../widgets/livewidget/query/QueryService'
], (APIFactory, InternalQueryServiceAPI, QueryService) => {
	class InternalQueryService {
		constructor(options) {
			this.dashboardApi = options.features['API'];
			this.queryService = new QueryService({
				dashboardApi: this.dashboardApi
			});
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [InternalQueryServiceAPI]);
			}
			return this.api;
		}

		executeQuery(sourceId, querySpec, senderId, requestOptions = {}) {
			return this.queryService.runQuery({
				sourceIdOrModule: sourceId,
				querySpec: querySpec,
				requestOptions: requestOptions,
				sender: senderId
			});
		}
	}

	return InternalQueryService;
});
